<div [class]="skinName">
  <div class="billing-history">
    <div class="billing-header">
      <a class="main-header" [routerLink]="['/account/settings']" > {{configService.localeKeys?.['common_keys.account.text'] || 'Account'}} </a>
      <img class="path-icon" src="branding/theme/assets/static_assets/ic-right.svg">
      <div class="sub-header"> {{configService.localeKeys?.['bil_his_title_bil_histr_def'] || 'Billing History'}} </div>
    </div>
    @if (billingData && billingData !== '{}') {
    <div class="tabs">
      @for (entry of paymentTypes; track entry) {
      <div class="tab" [ngClass]="{'tab-active': entry[0] === selectedTab}" (click)="selectTab(entry[0])">{{entry[1]}}</div>
      }
    </div>
    }
    @if (isMobile) {
      <!-- mobile responsive biiling history -->
      @if (selectedTab && selectedData?.paymentData?.length) {
        @for (item of selectedData?.paymentData; track item) {
          @if (selectedTab === 'subscriptions') {
            <div class="transaction-card">
              <div class="main-info">
                <div class="info-left">
                  <span> {{item?.transaction_date}} </span>
                  <span> {{item?.subscription_plan}} </span>
                </div>
                <div class="info-right"> {{item.paid_amount}} </div>
              </div>
              <div class="sub-info">
                <div class="sub-text">
                  <span> {{configService.localeKeys?.['bil_his_desc_service_prd_def'] || 'Service Period'}} </span>
                  <span> {{item?.service_period}} </span>
                </div>
                <div class="sub-text">
                  <span> {{configService.localeKeys?.['bil_his_desc_next_due_date_def'] || 'Next Due Date'}} </span>
                  <span> {{item?.next_due_date}} </span>
                </div>
                <div class="sub-text">
                  <span> {{configService.localeKeys?.['bil_his_desc_pmnt_prcsor_def'] || 'Payment processor'}} </span>
                  <span> {{item?.payment_processor}} </span>
                </div>
                <div class="sub-text">
                  <span> {{configService.localeKeys?.['bil_his_desc_trans_no_def'] || 'Transaction Number'}} </span>
                  <span> {{item?.transaction_id}} </span>
                </div>
              </div>
            </div>
          } @else if (selectedTab === 'rentals') {
            <div class="transaction-card">
              <div class="main-info">
                <div class="info-left">
                  <span> {{item?.transaction_date}} </span>
                  <span> {{item?.content_title}} </span>
                </div>
                <div class="info-right"> {{item.amount}} </div>
              </div>
              <div class="sub-info">
                <div class="sub-text">
                  <span> {{configService.localeKeys?.['account.rented_date.text'] || 'Rented Date'}} </span>
                  <span> {{item?.expiry_date}} </span>
                </div>
                <div class="sub-text">
                  <span> {{'Expiry Date'}} </span>
                  <span> {{item?.expiry_date}} </span>
                </div>
                <div class="sub-text">
                  <span> {{configService.localeKeys?.['bil_his_desc_pmnt_prcsor_def'] || 'Payment Processor'}} </span>
                  <span> {{item?.payment_processor}} </span>
                </div>
                <div class="sub-text">
                  <span> {{configService.localeKeys?.['bil_his_desc_trans_no_def'] || 'Transaction Number'}} </span>
                  <span> {{item?.transaction_id}} </span>
                </div>
              </div>
            </div>
          } @else if (selectedTab === 'purchases') {
            <div class="transaction-card">
              <div class="main-info">
                <div class="info-left">
                  <span> {{item?.transaction_date}} </span>
                  <span> {{item?.subscription_plan}} </span>
                </div>
                <div class="info-right"> {{item.amount}} </div>
              </div>
              <div class="sub-info">
                <div class="sub-text">
                  <span> {{configService.localeKeys?.['account.purchased_date.text'] ||'Purchased Date'}} </span>
                  <span> {{item?.transaction_date}} </span>
                </div>
                <div class="sub-text">
                  <span> {{configService.localeKeys?.['bil_his_desc_pmnt_prcsor_def'] || 'Payment Processor'}} </span>
                  <span> {{item?.payment_processor}} </span>
                </div>
                <div class="sub-text">
                  <span> {{configService.localeKeys?.['bil_his_desc_trans_no_def'] || 'Transaction Number'}} </span>
                  <span> {{item?.transaction_id}} </span>
                </div>
              </div>
            </div>
          }
        }
      }
    } @else {
      <!-- Billing histoty for web view -->
      @if (selectedTab && selectedData?.paymentData?.length) {
        <div class="transaction-table">
          <table>
            <thead>
              <tr>
                @for (item of selectedData?.headerData; track item) {
                <th> {{item}} </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (data of selectedData.paymentData; track data?.order_id) {
                @if (selectedTab === 'subscriptions') {
                  <tr>
                    <td> {{data.subscription_plan}} </td>
                    <td> {{data.service_period}} </td>
                    <td> {{data.next_due_date}} </td>
                    <td> {{data.payment_processor}} </td>
                    <td> {{data.transaction_id}} </td>
                    <td> {{data.paid_amount}} </td>
                  </tr>
                }
                @if (selectedTab === 'rentals') {
                  <tr>
                    <td> {{data.content_title}} </td>
                    <td> {{data.transaction_date}} </td>
                    <td> {{data.expiry_date}} </td>
                    <td> {{data.payment_type}} </td>
                    <td> {{data.transaction_id}} </td>
                    <td> {{data.amount}} </td>
                  </tr>
                }
                @if (selectedTab === 'purchases') {
                  <tr>
                    <td> {{data.content_title}} </td>
                    <td> {{data.transaction_date}} </td>
                    <td> {{data.payment_type}} </td>
                    <td> {{data.transaction_id}} </td>
                    <td> {{data.amount}} </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      }
    }
    @if (selectedTab && !selectedData?.paymentData?.length) {
      <div class="no-data">
        <span class="no-data-first"> {{noDataText?.textOne}} </span>
        @if (noDataText?.textTwo) {
          <a [routerLink]="['/home']"> {{'Click here'}} </a>
        }
        <span> {{noDataText?.textTwo}} </span>
      </div>
    }
  </div>
</div>